import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import shortid from "shortid";
//
import CouImagePreview from "./CouImagePreview";
import CouImageUploader from "./CouImageUploader";
//
const CouImageFieldsStyled = styled.div`
  margin: 0.5rem auto;
`;

class CouImageFields extends Component {
  state = {
    files: this.props.files || [],
  };

  addFile = (url, dimensions = null) => {
    const { multiple } = this.props;
    const nextFiles = multiple ? this.state.files : [];
    const file = {
      id: shortid.generate(),
      url,
      caption: "",
      dimensions,
    };
    nextFiles.push(file);

    this.setState({
      files: nextFiles,
    });
  };

  handleChange = (nextFiles) => {
    this.setState({
      files: nextFiles,
    });
  };

  render() {
    const { inputName, multiple, ...rest } = this.props;
    const { files } = this.state;

    const allowSort = multiple && files.length > 1;

    return (
      <CouImageFieldsStyled>
        <input type="hidden" name={inputName} value={JSON.stringify(files)} />
        <CouImagePreview
          files={files}
          handleChange={this.handleChange}
          multiple={allowSort}
        />
        <CouImageUploader
          files={files}
          handleFinish={this.addFile}
          multiple={multiple}
          {...rest}
        />
      </CouImageFieldsStyled>
    );
  }
}

CouImageFields.propTypes = {
  inputName: PropTypes.string.isRequired,
  multiple: PropTypes.bool.isRequired,
};

export default CouImageFields;
